export const isMaxLimitReached = (count: number, max?: number) => typeof max === 'number' && count >= max
